(() => {
  const root = document.querySelector('[data-crm-popup-root]');
  if (!root) return;
  const successMessage = root.dataset.successMessage || 'Cadastro realizado. Obrigado!';
  const errorMessage = root.dataset.errorMessage || 'Não foi possível enviar. Tente novamente.';
  const splitTags = (value) => (value || '').split(',').map((tag) => tag.trim()).filter(Boolean);
  const config = (() => {
    try {
      const base = new URL(root.dataset.apiUrl || '');
      const shopId = (root.dataset.shopId || '').trim();
      const token = (root.dataset.accessToken || '').trim().replace(/^Bearer\s+/i, '');
      if (base.protocol !== 'https:' || base.username || base.password || base.search || base.hash || !/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(shopId) || !token) return null;
      return { url: `${base.href.replace(/\/$/, '')}/v1/shops/${shopId}/leads/ingest`, token };
    } catch { return null; }
  })();
  const popups = [...root.querySelectorAll('[data-crm-popup]')];
  const open = (popup) => popup.showModal();
  popups.forEach((popup) => {
    let sending = false;
    let pendingBody = '';
    let pendingKey = '';
    popup.querySelector('[data-crm-popup-close]').addEventListener('click', () => popup.close());
    popup.addEventListener('click', (event) => { if (event.target === popup) popup.close(); });
    popup.querySelector('form').addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.currentTarget; const message = form.querySelector('[data-crm-popup-message]');
      if (sending || !form.reportValidity()) return;
      if (!config) { message.textContent = errorMessage; return; }
      const values = new FormData(form);
      const consent = {}; if (values.get('consent_email') === 'on') consent.email = true;
      const fields = Object.fromEntries(['first_name', 'email', 'phone'].map((name) => [name, String(values.get(name) || '').trim()]).filter(([, value]) => value));
      if (!fields.email && !fields.phone) { message.textContent = 'Informe e-mail ou telefone.'; return; }
      const tags = [...new Set([...splitTags(root.dataset.tags), ...splitTags(popup.dataset.tags), `popup:${popup.dataset.crmPopup}`])];
      const body = JSON.stringify({ ...fields, tags, ...(Object.keys(consent).length ? { consent } : {}), utm: { source: root.dataset.utmSource || 'shopify', medium: 'popup', campaign: values.get('utm_campaign') || popup.dataset.crmPopup } });
      if (body !== pendingBody || !pendingKey) {
        if (typeof crypto.randomUUID !== 'function') { message.textContent = errorMessage; return; }
        pendingBody = body;
        pendingKey = `lead:${crypto.randomUUID()}`;
      }
      sending = true;
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      message.textContent = 'Enviando…';
      const controller = new AbortController();
      const timeoutSeconds = Number(root.dataset.timeoutSeconds || 15);
      const timeout = window.setTimeout(() => controller.abort(), (Number.isFinite(timeoutSeconds) ? Math.min(60, Math.max(5, timeoutSeconds)) : 15) * 1000);
      try {
        const response = await fetch(config.url, { method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error', headers: { 'content-type': 'application/json', accept: 'application/json', Authorization: `Bearer ${config.token}`, 'Idempotency-Key': pendingKey }, body, signal: controller.signal });
        const data = await response.json().catch(() => null);
        if (response.status !== 201 || !['created', 'updated', 'matched_customer'].includes(data?.status)) throw new Error('CRM rejected submission');
        message.textContent = successMessage; form.reset();
        pendingKey = ''; pendingBody = '';
      } catch { message.textContent = errorMessage; }
      finally {
        window.clearTimeout(timeout);
        sending = false;
        if (button) button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
  });
  popups.filter((popup) => popup.dataset.openOnLoad === 'true').forEach((popup) => {
    const delay = Number(popup.dataset.openDelay || 0);
    window.setTimeout(() => { if (!popup.open) open(popup); }, Number.isFinite(delay) ? delay : 0);
  });
  document.addEventListener('click', (event) => { const trigger = event.target.closest('[data-crm-popup-open]'); if (!trigger) return; const popup = root.querySelector(`[data-crm-popup="${CSS.escape(trigger.dataset.crmPopupOpen)}"]`); if (popup) open(popup); });
})();

